export default __webpack_public_path__ + "static/media/tile-5-short.8fe11008.png";